
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://sanliubkpfaprqdvffyj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNhbmxpdWJrcGZhcHJxZHZmZnlqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMwODc0MTgsImV4cCI6MjA1ODY2MzQxOH0.pPY0pcvkYu4KLry09orzajpeuwOSS0avRxRsT9tGZ_0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
